import React from 'react';
import styled from 'styled-components';
import { CHEVRON_SMALL_ICON } from '@constants';
import Minus from '@images/icon-minus.svg';
import Plus from '@images/plus2.svg';
import LazyLoadImage from '../LazyLoadImage';

interface Props {
  isUsingArrows?: boolean;
  isSelected: boolean;
  iconsColor?: string;
  iconsSize?: string;
}

const AccordionItemExpandButton: React.FC<Props> = ({ isUsingArrows = false, isSelected, iconsColor, iconsSize }) => {
  if (isUsingArrows) {
    return (
      <ChevronWrap $isSelected={isSelected}>
        <LazyLoadImage src={CHEVRON_SMALL_ICON} />
      </ChevronWrap>
    );
  }
  return isSelected ? <IconMinus $iconsColor={iconsColor} $iconsSize={iconsSize} /> : <IconPlus $iconsColor={iconsColor} $iconsSize={iconsSize} />;
};

export default AccordionItemExpandButton;

const ChevronWrap = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    transition: 0.3s ease-in-out;
    transform: ${(props) => (props.$isSelected ? 'rotate(180deg)' : 'rotate(0deg)')};
    margin-bottom: ${(props) => (props.$isSelected ? '-3px' : '0')};
  }
`;

const IconPlus = styled(Plus)<{ $iconsColor?: string; $iconsSize?: string }>`
  margin-top: 5px;
  width: ${(props) => props.$iconsSize};
  min-width: ${(props) => props.$iconsSize};

  & path {
    fill: ${(props) => props.$iconsColor};
  }
`;

const IconMinus = styled(Minus)<{ $iconsColor?: string; $iconsSize?: string }>`
  margin-top: 11.5px;
  width: ${(props) => props.$iconsSize};

  & path {
    fill: ${(props) => props.$iconsColor};
  }
`;
